export default "__VITE_ASSET__KfHN$jB6__"